"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsPreviewMappers = void 0;
const componentExtensions_1 = require("./componentExtensions");
// import * as SlideShowGallery from './components/SlideShowGallery/SlideShowGallery.previewMapper'
exports.componentsPreviewMappers = Object.assign({}, componentExtensions_1.componentsMappers);
//# sourceMappingURL=componentPreviewExtensions.js.map